import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('./views/Products')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/Download')
    },
    {
      path: '/leecho',
      name: 'leecho',
      component: () => import('./views/LeEcho')
    },
    {
      path: '/products/ezb',
      name: 'ezb',
      component: () => import('./views/Products/Ezb')
    },
    {
      path: '/products/syx',
      name: 'syx',
      component: () => import('./views/Products/Syx')
    },
    {
      path: '/products/eyxp',
      name: 'eyxp',
      component: () => import('./views/Products/Eyxp')
    },
    {
      path: '/products/dyx',
      name: 'dyx',
      component: () => import('./views/Products/Dyx')
    },
    {
      path: '/products/_13',
      name: '_13',
      component: () => import('./views/Products/_13')
    },
    {
      path: '/products/glb',
      name: 'glb',
      component: () => import('./views/Products/Glb')
    },
    {
      path: '/products/s02',
      name: 's02',
      component: () => import('./views/Products/s02')
    },
    {
      path: '/products/s03',
      name: 's03',
      component: () => import('./views/Products/s03')
    },
    {
      path: '/products/glb_video',
      name: 'glb_video',
      component: () => import('./views/Products/Glb_video')
    },
    {
      path: '/products/five',
      name: 'glb_video',
      component: () => import('./views/Products/five')
    },
    {
      path: '/products/yx/:id',
      name: 'glb_video',
      component: () => import('./views/Products/yx')
    }
  ]
});
